import React from 'react';

import ShowOrHideOnBreakpoint from '../ShowOrHideOnBreakpoint';

import {IShowOnDesktopProps} from './IShowOnDesktop';

const ShowOnDesktop = (props: IShowOnDesktopProps) => {
	return <ShowOrHideOnBreakpoint query=">=small" {...props} />;
};

export default ShowOnDesktop;
